if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        /* for splide thumb */
        this.pr_gallery = this.querySelector('[id^="GalleryViewer"]');
        this.thumb_gallery = this.querySelector('[id^="GalleryThumbnails"]');
        this.checkGallery();
        /* for product sticky */
        this.sticky = this.querySelector('#product_page_sticky');
        this.initPrSticky();
        /* for coupon copy */
        this.initCopyAction();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      checkGallery(){
        var md = this.pr_gallery,td = this.thumb_gallery,m_rd = false,t_rd = false,cb = false;
        if(md && md.classList.contains('splide')){
          var md_ls = md.querySelectorAll('.splide__slide');
          md_ls.forEach(t=>{t.classList.remove('ov-slider-dk');t.classList.remove('ov-slider-tb');t.classList.remove('ov-slider-mb')});
          var m_galy = new Splide('#'+md.getAttribute('id'),JSON.parse(md.dataset.slick));
          wsp.sliderList[md.getAttribute('id')] = m_galy;
          m_rd = true;
        }
        if(td && td.classList.contains('splide')){
          var td_ls = td.querySelectorAll('.splide__slide');
          td_ls.forEach(t=>{t.classList.remove('ov-slider-dk');t.classList.remove('ov-slider-tb');t.classList.remove('ov-slider-mb')});
          var t_galy = new Splide('#'+td.getAttribute('id'),JSON.parse(td.dataset.slick));
          wsp.sliderList[td.getAttribute('id')] = t_galy;
          cb = true;
          t_rd = true;
        }
        if(cb)m_galy.sync(t_galy);
        if(m_rd)m_galy.mount();
        if(t_rd)t_galy.mount();
      }

      initPrSticky(){
        var pr = this,
        sky = this.sticky;
        if(sky){
          /* variant change */
          var sky_sl = sky.querySelector('.sticky_variant_select');
          if(sky_sl){
            sky_sl.addEventListener('change',function(e){
              var pf_vsl = pr.querySelector('variant-selects'),
              pf_sl = pf_vsl.querySelectorAll('select');
              if(pf_sl.length>0){
                //variant select
                var sky_val = e.target.querySelector('option:checked');
                var sky_ops = e.target.dataset.size,
                sky_opl = e.target.dataset.options.split(','),
                sky_val = e.target.querySelector('option:checked');
                for(let i = 1;i<=sky_ops;i++){
                  var index = i,t = pf_vsl.querySelector('select[name^="options['+ sky_opl[index-1]+']"]'),
                  x = pf_vsl.querySelector('select[name^="options['+ sky_opl[index-1]+']"] option[selected]');
                  if(sky_val.dataset['option'+i] != x.value){
                    t.value = sky_val.dataset['option'+i];
                    x.removeAttribute('selected');
                    t.querySelector('option[value="'+ sky_val.dataset['option'+i] +'"]').setAttribute('selected','selected');
                    t.closest('variant-selects').dispatchEvent(sticky_evt);
                  }
                }
              }else{
                //variant fieldset(no select)
                var sky_ops = e.target.dataset.size,
                sky_opl = e.target.dataset.options.split(','),
                sky_val = e.target.querySelector('option:checked');
                for(let i = 1;i<=sky_ops;i++){
                  var index = i,t = pf_vsl.querySelector('fieldset input[name^="'+ sky_opl[index-1]+'-'+i +'"][value="'+ sky_val.dataset['option'+i] +'"]');
                  if(!t.getAttribute('checked')){
                    t.click();
                  }
                }
              }
            });
          }
          /* btn add */
          var sky_btn = sky.querySelector('.sticky_btn_js');
          if(sky_btn){
            sky_btn.addEventListener('click',function(e){
              e.preventDefault();
              var t = e.target,
              fmid = t.dataset.target,
              fm = pr.querySelector('product-form form'+fmid);
              fm.querySelector('button[type="submit"]').click();
            });
          }
          /* for stikcy cart scroll */
          window.addEventListener('scroll',function (e) {
            var st = window.pageYOffset || document.documentElement.scrollTop,
            cw = window.innerWidth;
            if(cw > 768){
              var bh = document.body.scrollHeight  - document.querySelector('footer').offsetHeight*3;
              if(st > 1200 && st < bh){
                sky.classList.add('scrolled');
              }else{
                sky.classList.remove('scrolled');
              }
            }else{
              var bh = document.body.scrollHeight  - document.querySelector('footer').offsetHeight;
              if(st > 1500 && st < bh){
                sky.classList.add('scrolled');
              }else{
                sky.classList.remove('scrolled');
              }
            }
          })
        }
      }

      initCopyAction(){
        var claim = document.querySelectorAll('.qut_style');
        claim.forEach((e,i)=>{
          e.addEventListener('click',function(evt){
            var btn = evt.target,
            coupon = btn.dataset.coupon,
            cpt = document.createElement('input');
            cpt.value = coupon;
            document.body.append(cpt);
            cpt.select();
            try{
              if(document.execCommand('Copy')){
                cpt.className = 'copyboard';
                cpt.style = 'display:none;';
                var cp_parent = btn.closest('.pr_offer_item'),
                tip = cp_parent.querySelector('.special_offer_table_tip');
                if(!tip){
                  tip = document.createElement('div');
                  tip.innerHTML = '<span style="padding:5px 10px;background:rgba(164, 160, 159, 0.81);color:#fff">Coupon Copied!</span>'
                  tip.classList = 'special_offer_table_box special_offer_table_tip';
                  tip.style = "position:absolute;text-align:center";
                  cp_parent.querySelector('.pr_offer_detail').append(tip);
                  setTimeout(function(){
                    tip.remove();
                  },3000);
                }
              }
            }catch(error){
              console.log('error',error);
            }
            cpt.remove();
          });
        })
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        //console.log('change option',event);
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          //console.log(variant);
          //this.updateMedia(html, variant?.featured_media?.id);
          if(this.pr_gallery.classList.contains(wsp.slider.loaded)){
            var gls = this.pr_gallery.querySelectorAll('.product__media-item'),
            index = 0;
            gls.forEach(e=>{
              var idx = e.querySelector('img[src="'+ variant.featured_image.src +'&width=1946"]');
              if(idx){wsp.sliderList[this.pr_gallery.getAttribute('id')].go(index);}
              index++
            });
          }

          //sticky, available for sticky change variant callback or product form change variant callback.
          variant?.featured_image && this.sticky.querySelector('.sticky_img').setAttribute('src',variant?.featured_image.src);
          if(variant.compare_at_price > variant.price){
            var sky_sprice = this.sticky.querySelector('.pr_sticky_price .price__sale .price-item--regular'),
            sky_price = this.sticky.querySelector('.pr_sticky_price .price__sale .price-item--sale');
            sky_sprice.innerHTML = wsp.formatMoney(variant.compare_at_price);
            sky_price.innerHTML = wsp.formatMoney(variant.price);
          }else{
            var sky_price = this.sticky.querySelector('.pr_sticky_price .price__regular .price-item--regular');
            sky_price.innerHTML = wsp.formatMoney(variant.price);
          }
          this.sticky.querySelector('.sticky_variant_select').value = variant?.id;//only manual trigger <select>
          var sky_btn = this.sticky.querySelector('.sticky_btn_js');
          if(variant.available){
            //preorder
            if(variant.inventory_quantity<=0 && variant.inventory_policy == 'continue'){
              sky_btn.innerHTML = wsp.preorderTxt;
            }else{
              sky_btn.innerHTML = wsp.addBtnTxt;
            }
            sky_btn.removeAttribute('disabled');
          }
          else{
            sky_btn.innerHTML = wsp.soldBtnTxt;
            sky_btn.setAttribute('disabled','disabled');
          }

          /* breadcrumb sku */
          if(this.querySelector('.cur_sku_ppr'))this.querySelector('.cur_sku_ppr').innerHTML = variant.sku;

          /* diy */
          var diy = this.querySelector('#pr_diy_logo_ppr');
          if(diy){
            if(variant.is_diy){
              diy.closest('.cs_pr_file').classList.remove('dn');
              diy.removeAttribute('disabled');
            }else{
              diy.closest('.cs_pr_file').classList.add('dn');
              diy.setAttribute('disabled','disabled');
            }
          }
            
          /* label */
          var lb_e = this.pr_gallery.querySelector('.product__media-label');
          if(variant.compare_at_price>variant.price){
            var lb_s = Math.floor((variant.compare_at_price - variant.price)/variant.compare_at_price*100);
            if(lb_s>0){
              lb_e.innerHTML = `<span>- ${lb_s}%</span>`;
            }else{
              lb_e.innerHTML = '';
            }
          }else{
            lb_e.innerHTML = '';
          }

          /* estimated time */
          if(this.querySelector('.card_estimated_time')){
            if(variant.available == false || variant.inventory_policy == 'continue')
              this.querySelector('.card_estimated_time').classList.add('dn')
            else
              this.querySelector('.card_estimated_time').classList.remove('dn')
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut,
            (variant.inventory_quantity<=0 && variant.inventory_policy == 'continue')?true:false
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
